export default __webpack_public_path__ + "static/media/arrow-left.0f1c7eb7.svg";